export default __webpack_public_path__ + "static/media/upload.85db6da9.png";